import React from 'react';

function ErrorFragment() {
  return (
    <div>
      <div>
        You must have cookies enabled in your browser to
        get free full text access to this article on ScienceDirect.
      </div>
    </div>
  );
}

export default ErrorFragment;
